import { motion } from "framer-motion";
import { PickCard, PickCardSkeleton } from "./Cards";
import useResponsive from "helpers/useResponsive";
import { useQuery } from "react-query";
import selection from "helpers/api/selection";
import moment from "moment";
import { useEffect, useState } from "react";

const notFoundIcon = require("assets/images/not-found.svg");
const chevronIcon = require("assets/images/chevron-black.svg");

export default function Today() {
  const { isTablet, isMobileLandScape } = useResponsive();
  const { data, isLoading } = useQuery("todays-selections", () =>
    selection.get(moment().format("YYYY-MM-DD"))
  );
  const [filtered, setFiltered] = useState([]);
  const [isTabletDropdownOpen, setisTabletDropdownOpen] = useState(true);

  //   get the data that has winningProbability of under 70%
  useEffect(() => {
    if (!isLoading && data) {
      setFiltered(data.filter((item: any) => item.winningProbability < 70));
    }
  }, [data, isLoading]);

  if (isLoading) {
    return (
      <div
        className={`p-[1.5rem] bg-[white] rounded-[12px] ${
          isTablet ? "w-full" : "w-full"
        } h-fit overflow-hidden`}
        // initial={{
        //   opacity: 0,
        // }}
        // whileInView={{ opacity: 1 }}
        // transition={{ duration: 0.5 }}
        // viewport={{ once: true }}
        // exit={{ opacity: 0 }}
        style={{
          height: "fit-content",
        }}
      >
        <PickCardSkeleton />
      </div>
    );
  }

  return (
    <motion.div
      className={`pb-[1.5rem] bg-[white] rounded-[12px] w-full overflow-hidden min-h-[4.6875rem]`}
      // style={{
      //   height: isTabletDropdownOpen ? "auto" : "4.6875rem",
      // }}
      initial={"open"}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      animate={isTabletDropdownOpen ? "open" : "closed"}
      variants={{
        open: { maxHeight: "100%" },
        closed: { maxHeight: "4.6875rem" },
      }}
      exit={{ opacity: 0 }}
    >
      <button
        className={`p-[1.5rem] text-[1.125rem] font-[500] uppercase flex justify-between w-full text-start items-center transition-all
        hover:opacity-70
        `}
        onClick={() => setisTabletDropdownOpen(!isTabletDropdownOpen)}
      >
        <div className="grid gap-1">Today's Selections</div>
        <motion.div
          className={isTabletDropdownOpen ? "transform rotate-180" : ""}
          initial={false}
          animate={isTabletDropdownOpen ? "open" : "closed"}
          variants={{
            open: { rotate: 180 },
            closed: { rotate: 0 },
          }}
        >
          <chevronIcon.ReactComponent />
        </motion.div>
      </button>

      <div className="grid gap-[1.125rem] p-4">
        {filtered.length > 0 ? (
          filtered.map((item: any, index: number) => (
            <PickCard key={index} data={item} />
          ))
        ) : (
          <div className="grid gap-[1.125rem] my-[10rem] items-center justify-items-center">
            <notFoundIcon.ReactComponent />
            <span className="font-[500] text-[1.125rem]">
              No selections for today
            </span>
          </div>
        )}
      </div>
    </motion.div>
  );
}
